import {
  CheckboxInput,
  type CheckboxInputProps,
} from "@repo/ui/components/Base/CheckboxInput";
import { useFormikContext } from "formik";

interface FormikCheckboxProps extends CheckboxInputProps {
  name: string;
}

export const FormikCheckbox = ({ ...props }: FormikCheckboxProps) => {
  const { setFieldValue } = useFormikContext();
  return (
    <CheckboxInput
      onCheckedChange={(checked) => setFieldValue(props.name, checked)}
      {...props}
    />
  );
};
